// src/components/StaffSidebar.jsx
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaTachometerAlt,
  FaBookOpen,
  FaClipboardList,
  FaUsers,
  FaChartBar,
  FaBullhorn,
  FaFileAlt,
  FaChalkboardTeacher,
  FaSignOutAlt,
} from "react-icons/fa";

import "../assets/css/staff-sidebar.css";

const navItems = [
  { path: "/staff/dashboard", label: "Dashboard", icon: <FaTachometerAlt /> },
  { path: "/staff/courses", label: "Courses", icon: <FaBookOpen /> },
  { path: "/staff-results", label: "Results Entry", icon: <FaFileAlt /> },
  { path: "/staff/attendance", label: "Attendance", icon: <FaClipboardList /> },
  {
    path: "/staff/assignments",
    label: "Assignments & Quizzes",
    icon: <FaChalkboardTeacher />,
  },
  { path: "/staff/students", label: "Student Profiles", icon: <FaUsers /> },
  {
    path: "/staff/announcements",
    label: "Announcements",
    icon: <FaBullhorn />,
  },
  { path: "/staff/reports", label: "Analytics", icon: <FaChartBar /> },
  { path: "/hod/admin-register", label: "Admin Register", icon: <FaUsers /> },
];


const HODSidebar = () => {
  
  const location = useLocation();
  const navigate = useNavigate();
  const userName = localStorage.getItem("fullName") || "User";
  console.log("User Name:", userName);
  console.log("fullName from localStorage:", localStorage.getItem("fullName"));
  const handleLogout = () => {
    /* remove keys… */
    navigate("/");
  };

  return (
    <nav className="staff-sidebar">
      <div className="sidebar-header">
        <h2>Staff Portal</h2>
        <p className="welcome-text">Welcome, {userName}</p>
      </div>

      <ul className="sidebar-nav">
        {navItems.map((item) => (
          <li
            key={item.path}
            className={
              location.pathname === item.path ? "nav-item active" : "nav-item"
            }
          >
            <Link to={item.path} className="nav-link">
              <span className="icon">{item.icon}</span>
              <span className="label">{item.label}</span>
            </Link>
          </li>
        ))}

        {/* Logout at bottom */}
        <li className="nav-item logout">
          <button
            type="button"
            className="nav-link logout-link"
            onClick={handleLogout}
          >
            <span className="icon">
              <FaSignOutAlt />
            </span>
            <span className="label">Logout</span>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default HODSidebar;
